export default "__VITE_ASSET__Dizebyb___"